const durationSecond = 1000;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;
export { durationDay, durationHour, durationMinute, durationMonth, durationSecond, durationWeek, durationYear };
//# sourceMappingURL=duration.js.map
